import { useMotionValue, MotionProps } from 'framer-motion';
import { useMemo } from 'react';
import { CSSProperties } from 'styled-components';

export const useAccordionAnimation = (props?: { isExpanded?: boolean }) => {
    const isBeingKeptMounted = !!props;
    const isExpanded = props?.isExpanded;

    const overflow = useMotionValue<CSSProperties['overflow']>(null);
    const display = useMotionValue<CSSProperties['display']>(
        isBeingKeptMounted && isExpanded ? null : 'none'
    );

    return useMemo((): MotionProps => {
        const commonProps: MotionProps = {
            transition: { duration: 0.3, ease: [0.8, 0, 0.2, 1] },
            style: { overflow, display },
            // this is needed because we want to hide overflow only while animating.
            // If overflow was hidden all the time, dropdowns/popovers near the bottom of the item will be cut off.
            onAnimationStart: () => {
                overflow.set('hidden');
                display.set(null);
            },

            onAnimationComplete: (animation: typeof COLLAPSED) => {
                overflow.set(null);
                if (animation === COLLAPSED) {
                    display.set('none');
                }
            }
        };

        return isBeingKeptMounted
            ? {
                  ...commonProps,
                  initial: false,
                  animate: isExpanded ? OPEN : COLLAPSED
              }
            : {
                  ...commonProps,
                  initial: COLLAPSED,
                  animate: OPEN,
                  exit: COLLAPSED
              };
    }, [isBeingKeptMounted, isExpanded, overflow, display]);
};

const OPEN = { height: 'auto' } as const;
const COLLAPSED = { height: 0 } as const;
